"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardView = void 0;
var React = require("react");
var Card_1 = require("./Card");
var CardView_styles_1 = require("./CardView.styles");
var CardView = function (_a) {
    var children = _a.children;
    var isSingleCard = React.Children.count(children) === 1;
    return (React.createElement(CardView_styles_1.WrapperDiv, { Height: isSingleCard ? "100%" : "auto" }, React.Children.map(children, function (card, index) {
        // If there's only one card make it full height
        return (isSingleCard) ?
            React.createElement(CardView_styles_1.SingleCardWrapperDiv, null,
                React.createElement(Card_1.Card, __assign({}, card.props)))
            :
                // No margin top for the first item
                (index > 0) ?
                    React.createElement(CardView_styles_1.NonInitialCardWrapperDiv, null,
                        React.createElement(Card_1.Card, __assign({}, card.props)))
                    :
                        React.createElement(Card_1.Card, __assign({}, card.props));
    })));
};
exports.CardView = CardView;
